import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlRoomFactorDtl from "./HtlRoomFactorDtl";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $rTypeCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_htl_room_type(where: {r_type_code: {_eq: $rTypeCode}
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
    r_type_code
    r_type_name
    firm_main_code
    firm_sub_code
    
  }
  tbl_htl_room_type_factor(where: {r_type_code: {_eq: $rTypeCode}, firm_sub_code: {_eq: $ownFirmSubCode}}) {
    
    firm_main_code
    firm_sub_code
    r_type_code
    per_type
    person
    per_factor
    factor_id
    
  }
  
}
`;

const INSERT_SEA = gql`
  mutation InsertSeason(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
   
    
  ) {
    insert_tbl_dyn_price_grp_def_main(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        dyn_grp_id: $seaId,
        dyn_grp_desc: $seaDesc,
        start_date: $startDate,
        end_date: $endDate,
        active: $fmActive

        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
    $seaId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $seaDesc: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
  ) {
    update_tbl_dyn_price_grp_def_main(
      where: {
        dyn_grp_id: { _eq: $seaId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        dyn_grp_desc: $seaDesc
        active: $fmActive
        start_date: $startDate
        end_date: $endDate
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlRoomFactor = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode3, setVarCode3} = useContext(ThemeContext);
   const {varCode4, setVarCode4} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { rTypeCode: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode  },
  });


  const firmData = data && data.tbl_htl_room_type ? data.tbl_htl_room_type[0] : null;
  const firmData2 = data && data.tbl_htl_period ? data.tbl_htl_period[0] : null;
 

  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
  const [seaDesc, setSeaDesc] = useState(firmData ? firmData.r_type_name : ""); 
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.r_type_code : ""); 
  const [seaId, setSeaId] = useState("");
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);
  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const new_factor_btn = messages[currentLocale].new_factor_btn;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_type_code = messages[currentLocale].room_type_code;
  const room_type_name = messages[currentLocale].room_type_name;
  const rule_person_title = messages[currentLocale].rule_person_title;
  const factor_title = messages[currentLocale].factor_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const room_person_factor_dtl_title = messages[currentLocale].room_person_factor_dtl_title;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const per_id_title = messages[currentLocale].per_id_title;
  const per_code_title = messages[currentLocale].per_code_title;
  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const typerec = messages[currentLocale].typerec;



  



  const close_form = messages[currentLocale].close_form;
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const sea_new_btn = messages[currentLocale].sea_new_btn;
  const sea_Season_title = messages[currentLocale].sea_Season_title;
  
 
  const sea_management_title = messages[currentLocale].sea_management_title;
  const detail = messages[currentLocale].detail;
  
  const sea_id_title = messages[currentLocale].sea_id_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const sea_desc_title = messages[currentLocale].sea_desc_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


  

  useEffect(() => {
    if (firmData) {
  
        setSeaId(firmData.dyn_grp_id);
        setStartDate(new Date(firmData.start_date));
        setEndDate(new Date(firmData.end_date));
        setSeaDesc(firmData.r_type_name);
        setRTypeCode(firmData.r_type_code);
          
    }
  }, [firmData]);


  



  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
    setVarCode2(''); 
    setVarCode(rTypeCode);    
    setVarCode3(0);
    setVarCode4(0)
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };




  return (

    <div className="container p-2 mx-auto sm:p-4 ">
      <div className="card  ">
    
     <div className=" p-2 ">
          <div className="pt-1 -my-14 -ml-14 -mr-14  -mb-5"> 
            <Fieldset>
            <p className="my-0  ">

          <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{room_type_code}</label>
    <InputText className="w-full text-base" 
    id="username" value={varCode}
    onChange={(e) => setSeaId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-4/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{room_type_name}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={seaDesc} 
    onChange={(e) => setSeaDesc(e.target.value)} autoComplete="off"/>
    
  </div>
 
  </div>

  
  <div className="flex gap-3 my-5">
  
  
      
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_factor_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '45vw' }}header={room_person_factor_dtl_title} onHide={onHide}>
  <p>
  <HtlRoomFactorDtl/>
  </p>
</Dialog>
</div>

</p>
    </Fieldset>
        </div>
  
             
        </div>          
       

    
   </div>
  
    <p> <DataTable
         value={data.tbl_htl_room_type_factor}
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="r_type_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{room_type_tab}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="per_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{typerec}</span>}
           style={{ textAlign: 'left', width: '8rem' }}
          >
          </Column>

          <Column field="person"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_person_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

          <Column field="per_factor"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{factor_title}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>

        

          
          <Column
          header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode2(rowData.per_type);  
                setVarCode(rowData.r_type_code); 
                setVarCode3(rowData.person);  
                setVarCode4(rowData.factor_id)                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>
        
     
    </div>

    
    
    
 
 
);
};

export default HtlRoomFactor;
